import { getInitialData } from "common/utils/initialization";
import { IntegrationSettings } from "common/types/accounts";
import type { PostHogAnalyticsUser } from "common/contexts/PostHogAnalyticsProvider";

import { Clinic } from "client/clinics/types";
import { AuthenticationSource } from "client/accounts/types";
import type { Experiment } from "client/analytics/types";

/** matches ClientBundle._get_initial_user_data */
type ClientPostHogAnalyticsUser = PostHogAnalyticsUser & {
  client_id: number;
};

/** matches general ClientBundle initial_data */
export type InitialData = {
  clinic: Clinic;
  is_authenticated: boolean;
  auth_source: AuthenticationSource | null;
  has_completed_signup: boolean;
  is_staff: boolean;
  vetcove_support_phone: number;
  vetcove_support_email: string;
  vetcove_support_hours: string;
  vetcove_phone_support_hours: string;
  user_id: number | null;
  user: ClientPostHogAnalyticsUser | null;
  intercom_id: string;
  intercom_user_hash: string | null;
  integration_settings: IntegrationSettings;
  has_internal_analytics_tracking: boolean;
  /** matches FeaturesController.get_experiment_variants_for_shopper */
  experiments?: Partial<Record<Experiment, string>>;
  debug_analytics_events: boolean;
};

export const INITIAL_CLIENT_DATA = getInitialData<InitialData>();
